import $ from 'jquery';

/* eslint-disable no-unused-vars */
import Carousel from 'bootstrap/js/dist/carousel';
/* eslint-enable */

$( document ).ready( function() {
	$( document ).on( 'slide.bs.carousel', '.carousel', function( ev ) {
		const HIDDEN_CLASS = 'd-none';

		$( this ).find( '.extras .slide-content' ).addClass( HIDDEN_CLASS ).filter( function() {
			return parseInt( $( this ).attr( 'data-bs-slide' ) ) === parseInt( ev.to );
		} ).removeClass( HIDDEN_CLASS );
	} );
} );

$( document ).ready( function() {
	if ( 'undefined' !== typeof $.fn.slickFilterable ) {
		$( '.sliderwrap' ).slickFilterable( {
			filterName: 'filter-heading',
			filter( category ) {
				return $( this ).hasClass( category );
			},
			slick: {
				infinite: false,
				prevArrow: '<i class="fa fa-angle-left"></i>',
				nextArrow: '<i class="fa fa-angle-right"></i>',
				dots: false,
				adaptiveHeight: true,
			},
		} );
	}
} );
